<div class="container px-4">
  <div class="my-services-page">
    <!-- Header Section -->
    <header class="page-header">
      <h1>My Services</h1>
      <p>Manage your products and services.</p>
    </header>

    <!-- Services Section -->
    <div class="services-card">
      <div class="service-header">
        <div class="service-info">
          <h2>Internet</h2>
          <p>Residential 10Gig</p>
        </div>
        <button
          class="change-plan-button"
          type="button"
          (click)="handleRoute()"
        >
          Change plan
        </button>
      </div>
      <div class="service-details flex justify-center flex-wrap md:flex-row flex-col gap-4 md:gap-0">
        <div class="detail">
          <div class="icon">
            <img src="/dashboard/download.png" alt="download" />
          </div>
          <p>Download speed</p>
          <strong>10000 Mbps</strong>
        </div>
        <div class="divider hidden md:block"></div>
        <div class="detail flex flex-col justify-center items-center">
          <div class="flex flex-col justify-center items-center pb-3">
            <img src="/dashboard/upload.png" alt="upload" />
          </div>
          <p>Upload speed</p>
          <strong>10000 Mbps</strong>
        </div>
      </div>
    </div>
  </div>
</div>
